import { GlobalState } from '@leverege/ui-redux';
import ImagineDeviceApi from "../../api/ImagineDeviceApi.js";
import AbstractFotaItemDelegate from "../AbstractFotaItemDelegate.js";
export default class DeviceItemDelegate extends AbstractFotaItemDelegate {
  constructor(options) {
    super(options);
    const {
      relationship
    } = options;
    this.imagineDeviceApi = new ImagineDeviceApi({
      relationship
    });
  }
  getApi() {
    return this.api.device();
  }
  getImagineGroup() {
    const device = this.getItem();
    return this.imagineDeviceApi.getSystemOrDevice(device?.imagineGroupId);
  }
  getImagineGroupItem(state = GlobalState.get()) {
    const device = this.getItem();
    if (!device?.imagineGroupId) {
      return null;
    }
    return state?.models?.lookup[device?.imagineGroupId];
  }
}